export default "__VITE_ASSET__0be7bbef__"